import { Routes } from '@/routes';

export default {
	'content-block.index': () => import('@/modules/content-block/index'),
	'content-block.new': () => import('@/modules/content-block/form'),
	'content-block.edit': () => import('@/modules/content-block/form'),
} as Routes;
